import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { find, has, map } from "lodash";
import { Series } from "../../store/metrics/state";
import { LineExpandedComponent } from "../../charts/line-expanded/line-expanded.component";

@Component({
  selector: "mz-trend-chart",
  templateUrl: "./mz-trend-chart.component.html",
  styleUrls: ["./mz-trend-chart.component.scss"],
})
export class MzTrendChartComponent implements OnInit, OnChanges {
  @Input() viewType: string;
  @Input() chartData;
  @Input() loading;
  @Input() categories;
  @Input() data;
  @Input() min;
  @Input() max;
  @Input() filterByText;
  @Input() contentText;
  @Input() selectedCompareBy;
  @Input() selectedSubArea;
  @Input() noComparisonText;

  @ViewChild("chart") chart: LineExpandedComponent;
  @Output() chartDataUpdated = new EventEmitter();
  @Output() changeViewTypeEvent = new EventEmitter();
  @Output() exportCSV = new EventEmitter();

  highlightedItem: Series;
  tooltipDescriptor: string = "";
  tooMuchData = false;
  constructor() {}

  ngOnInit() {
    if (
      has(this.data, "lightbox.charts.overall.chartData") &&
      this.data.lightbox.charts.overall.chartData &&
      this.data.lightbox.charts.overall.chartData.length > 0
    ) {
      // get tooltip descriptor
      this.tooltipDescriptor = this.data.lightbox.charts.overall.chartData[0].descriptor;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.chartData) {
      this.tooMuchData = this.chartData && this.chartData.length > 2000;
    }
  }

  highlight(item) {
    if (this.highlightedItem && item.name == this.highlightedItem.name) {
      // we already have this item highlighted from the initial highlight
      return;
    } else if (this.highlightedItem && item.name != this.highlightedItem.name) {
      // we have an existing highlighted item from when we set the most recent series to be highlighted initially
      // and it is not equal to the currently highlighted item, so unhighlight the existing highlighted item
      this.unhighlight(this.highlightedItem, true);
    }
    this.highlightedItem = item;
    if (this.chart.chart && this.chart.chart.series) {
      let matchingSeries = find(this.chart.chart.series, ["name", item.name]);
      if (matchingSeries) {
        matchingSeries.onMouseOver();
      }
    }
  }

  unhighlight(item, removeExistingHighlight: boolean = false) {
    if (!removeExistingHighlight) {
      this.highlightedItem = null;
    }
    if (this.chart.chart && this.chart.chart.series) {
      let matchingSeries = find(this.chart.chart.series, ["name", item.name]);
      if (matchingSeries) {
        matchingSeries.onMouseOut();
      }
    }
  }

  toggleSeriesVisibility(seriesName) {
    // toggle chart data visibility so legend item shows enabled/disabled, map so we preserve immutability of chartData
    this.chartData = map(this.chartData, (series: Series) => {
      if (series.name == seriesName) {
        return { ...series, visible: !series.visible };
      } else {
        return series;
      }
    });
    if (this.chart.chart && this.chart.chart.series) {
      let matchingSeries = find(this.chart.chart.series, ["name", seriesName]);
      if (matchingSeries) {
        matchingSeries.setVisible(!matchingSeries.visible, true);
      }
    }
    this.chartDataUpdated.emit(this.chartData);
  }

  toggleLegendHighlight(index: number, isHighlighted: boolean) {
    if (isHighlighted && this.chartData && this.chartData[index]) {
      if (
        this.highlightedItem &&
        this.highlightedItem.name != this.chartData[index].name
      ) {
        // we have an existing highlighted item from when we set the most recent series to be highlighted initially
        // and it is not equal to the currently highlighted item, so unhighlight the existing highlighted item
        this.unhighlight(this.highlightedItem, true);
      }
      this.highlightedItem = this.chartData[index];
    } else {
      this.highlightedItem = null;
    }
  }

  hideMZInfoMessage() {
    localStorage.setItem("largeDatasetInfoMessageTrend", "hidden");
  }

  isHiddenInLocalStorage() {
    return localStorage.getItem("largeDatasetInfoMessageTrend") == "hidden";
  }
}
